import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import { Tabs, Tab, Dialog, DialogContent, Button, IconButton } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useDataProvider, usePermissions, useTranslate } from 'react-admin';
import { Close, } from '@material-ui/icons'
import imageInfo from '../assets/infochanges.png';
import General from './GeneralRoom';
import DeviceList from './DeviceList';
import ChannelList from './ChannelList';
import Settings from '../settings'
import CloseButton from '../CustomizedUIs/CloseButton';
import Relatives from '../relative-user/list';
import Services from '../ExternalService/listofroom'
import { LoadingButton } from '../common/button';
import MyCalendar from "../calendar";
import MessageAlarm from '../messageAlarm';
import ExternalDeviceList from '../ExternalDevice/list';
const useStyles = makeStyles(theme => ({
    selected: {
        backgroundColor: theme.tab.selectedColor,
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
        color: '#ffffff !important',
    },
    indicator: {
        backgroundColor: '#ffffff',
        height: 5
    },
    tabRoot: {
        width: 155,
        height: 60,
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
        color: 'rgba(255, 255, 255, 0.7)',
    },
    dialogPaper: {
        minHeight: '90vh',
        maxHeight: '90vh',
        backgroundColor: theme.palette.background.default
    },
    textClose: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.4px',
        color: '#4f5064',
    },
    btnClose: {
        width: '28px',
        height: '28px',
        border: 'solid 2px #e5f1f8',
        backgroundColor: '#ffffff',
        padding: 0
    },
    TitleCluster: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    TitleEntity: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '12px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    paper: {
        display: 'block'
    },
    container: {
        width: 450,
        textAlign: 'center',
        backgroundColor: '#f3f7fa',
        paddingBottom: theme.spacing(5)
    },
    borderClose: {
        width: '25px',
        height: '25px',
        border: 'solid 2px #e5f1f8',
        backgroundColor: '#ffffff',
        marginLeft: '10px'
    },
    titleUnSave: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '22px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    contentUnSave: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
        paddingTop: '10px'
    },
    btnCancel: {
        fontFamily: 'UniviaPro',
        fontSize: '10px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.4px',
        color: '#237fc2',
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box display='flex' justifyContent={props.justifyContent || 'center'} p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}



const EditRoomDialog = ({ readOnly, open, handleClose, data, openDialogAlertInRoom, setEditRoomData,
    setOpenDialogAlertInRoom, isChangeInRoom, setIsChangeInRoom, setIsCloseEditInRoom, isCloseEditInRoom, ...props }) => {
    const translate = useTranslate();
    const classes = useStyles()
    const theme = useTheme();
    const [isSaveInRoom, setIsSaveInRoom] = useState(false)
    const [valueDialogEditRoom, setValueDialogEditRoom] = useState(0);
    const [newValueDialogEditRoom, setNewValueDialogEditRoom] = useState(2);
    const { permissions, loaded } = usePermissions();
    const handleChange = (event, newValue) => {
        console.log(newValue)
        setValueDialogEditRoom(newValue);
    };

    const onSave = () => {
        setOpenDialogAlertInRoom(false)
        setIsSaveInRoom(true)
        setIsChangeInRoom(false)
    }
    const handleCloseDialogAlert = () => {
        setOpenDialogAlertInRoom(false)
        setNewValueDialogEditRoom(2)
    }

    const handleCancelDialog = () => {
        if (isCloseEditInRoom === true && newValueDialogEditRoom === 2) {
            setIsCloseEditInRoom(false)
        }
        setOpenDialogAlertInRoom(false)
        setValueDialogEditRoom(newValueDialogEditRoom)
        setNewValueDialogEditRoom(2)
        setIsChangeInRoom(false)
    }


    React.useEffect(() => {
        setValueDialogEditRoom(0)
    }, [open]);


    if (!open || !loaded) return null

    return (
        <Dialog
            open={open}
            scroll='paper'
            classes={{ paper: classes.dialogPaper }}
            fullWidth={true}
            maxWidth='xl'>
            <Box mt={3}>

                <Dialog open={openDialogAlertInRoom} onClose={handleCloseDialogAlert} aria-labelledby="form-dialog-title" classes={{
                    paper: classes.paper
                }} >
                    <Box className={classes.container}>
                        <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} pt={1}>
                            <Typography className={classes.textClose}>{translate(`pos.common.close`)}</Typography>
                            <IconButton className={classes.borderClose} onClick={handleCloseDialogAlert} >
                                <Close color='primary' />
                            </IconButton>
                        </Box>
                        <img alt='image-save' src={imageInfo} className={classes.image} />
                        <Typography className={classes.titleUnSave}>{translate('resources.role.titleUnsave')}</Typography>
                        <Typography className={classes.contentUnSave}>{translate('resources.role.contentUnsave')}</Typography>

                        <Box mt={3}>
                            <Button
                                style={{ marginTop: 16, marginRight: 20 }}
                                onClick={handleCancelDialog}
                            >
                                <Typography className={classes.btnCancel}>{translate(`pos.dashboard.CANCEL`)}</Typography>
                            </Button>
                            <LoadingButton
                                label={translate(`resources.role.Save`)}
                                onClick={onSave}
                            />
                        </Box>
                    </Box>
                </Dialog>
                <Box mb={3} ml={4} display='flex' justifyContent='flex-end'>
                    <Box display='flex' alignContent='center' mr={3}>
                        <Typography style={{ margin: 'auto 8px auto 0' }} className={classes.textClose}>  {translate(`pos.dashboard.close`)}</Typography>
                        <CloseButton onClick={handleClose} />
                    </Box>
                </Box>
                <AppBar position="static" color='primary'>
                    <Tabs
                        variant="fullWidth"
                        value={valueDialogEditRoom}
                        onChange={handleChange}
                        classes={{
                            indicator: classes.indicator
                        }}
                        centered
                    >
                        <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.general`)}{...a11yProps(0)} />
                        <Tab disabled={!permissions.functionAction.find(value => value.function === 'Unit' && value.isRead)}
                            classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.device(s)`)} {...a11yProps(1)} />
                        <Tab disabled={!permissions.functionAction.find(value => value.function === 'Room settings' && value.isRead)}
                            classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.settings`)} {...a11yProps(2)} />
                        <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.relative`)}{...a11yProps(3)} />
                        <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.externalDevice`)} {...a11yProps(4)} />
                        <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate(`resources.room.externalService`)} {...a11yProps(5)} />
                        <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate('resources.room.channelLists')} {...a11yProps(6)} />
                        <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate('resources.room.calendar')} {...a11yProps(7)} />
                        <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate('resources.messageAlarm.messageAlarmTitle')} {...a11yProps(8)} />


                    </Tabs>
                </AppBar>
            </Box>

            <DialogContent dividers={false} id='containerRoomEditDialog'>
                <TabPanel value={valueDialogEditRoom} index={0} dir={theme.direction} justifyContent='flex-start'>
                    <General
                        readOnly={readOnly}
                        {...props}
                        data={data}
                        handleClose={handleClose}
                    />
                </TabPanel>
                <TabPanel value={valueDialogEditRoom} index={1} dir={theme.direction}>
                    <DeviceList
                        readOnly={!permissions.functionAction.find(value => value.function === 'Unit' && value.isUpdate)}
                        roomData={data.roomData}>
                    </DeviceList>
                </TabPanel>
                <TabPanel value={valueDialogEditRoom} index={2} dir={theme.direction}>
                    <Settings cluster={data.roomData.cluster} room={data.roomData.id} isSaveInRoom={isSaveInRoom} setIsSaveInRoom={setIsSaveInRoom} setEditRoomData={setEditRoomData}
                        isChangeInRoom={isChangeInRoom} setIsChangeInRoom={setIsChangeInRoom} setValueDialogEditRoom={setValueDialogEditRoom} newValueDialogEditRoom={newValueDialogEditRoom} />
                </TabPanel>
                <TabPanel value={valueDialogEditRoom} index={3} dir={theme.direction}>
                    <Relatives data={data.roomData} />
                </TabPanel>
                <TabPanel value={valueDialogEditRoom} index={4} dir={theme.direction}>
                    <ExternalDeviceList roomID={data.roomData.id} roomData={data.roomData} />
                </TabPanel>
                <TabPanel value={valueDialogEditRoom} index={5} dir={theme.direction}>
                    <Services data={data.roomData} />
                </TabPanel>

                <TabPanel value={valueDialogEditRoom} index={6} dir={theme.direction}>
                    <ChannelList
                        from='room'
                        data={data.roomData}
                        permissions={permissions}
                    />
                </TabPanel>
                <TabPanel value={valueDialogEditRoom} index={7} dir={theme.direction}>
                    <MyCalendar mainContainerStyle={{ width: '100vh', padding: 0 }} roomData={data.roomData} />
                </TabPanel>
                <TabPanel value={valueDialogEditRoom} index={8} dir={theme.direction}>
                    <MessageAlarm roomID={data.roomData.id} />
                </TabPanel>
            </DialogContent>


        </Dialog>

    );
}
export default EditRoomDialog